// ================================================================
// CustomersView — karte moshtari (mostaghel az CompanyDashboard)
// list + jostoju + jozئiyat + timeline-e Interaction
// CompanyDashboard faghat 3 noghte-ye ettesal darad (menu, render, action)
// Sprache: alle sichtbaren Texte über t() — Keys in i18n/de.json + en.json.
// ================================================================
import { icon, escapeHtml } from '../../utils/dom.js';
import { listCustomers, getCustomer, createCustomer, listTrashedCustomers, trashCustomer, restoreCustomer, deleteCustomerPermanent, createContactPerson } from '../../core/customers.js';
import { time, monthLong } from '../../utils/format.ts';
import { t } from '../../i18n/index.js';

// state-e mostaghel-e in view
const cs = {
  loading: false,
  error: '',
  loaded: false,
  fullList: [],
  list: [],
  search: '',
  selectedId: null,
  detail: null,       // { customer, interactions }
  detailLoading: false,
  detailError: '',
  // form-e sakht-e moshtari-ye dasti (controlled — dar state, na DOM)
  showNewForm: false,
  newBusy: false,
  newError: '',
  newForm: { name: '', phone: '', street: '', plz: '', city: '', email: '', persons: [] },
  // satl-e ashghal
  showTrash: false,
  trashList: [],
  trashLoading: false,
  trashError: '',
  // menu-ye rast-click: { id, name, x, y } ya null
  ctxMenu: null,
  actionBusyId: null,  // dar hal-e trash/restore/delete
};

// CompanyDashboard input listener in ra seda mizanad (controlled inputs)
export function openCustomerContextMenu(id, name, x, y) {
  cs.ctxMenu = { id, name, x, y };
  redraw();
}

export function handleNewCustomerField(field, value) {
  if (cs.newForm && field in cs.newForm) cs.newForm[field] = value;
}

// controlled input baraye field-haye rabet (persons[idx][field])
export function handleNewCustomerPersonField(idx, field, value) {
  const arr = cs.newForm && cs.newForm.persons;
  if (arr && arr[idx] && field in arr[idx]) arr[idx][field] = value;
}

let _redraw = null; // callback baraye redraw-e CompanyDashboard

// CompanyDashboard in ra seda mizanad ta redraw momken bashad
export function initCustomers(redrawFn) {
  _redraw = redrawFn;
}

function redraw() { if (_redraw) _redraw(); }

// ── data loading ──
export async function loadCustomers() {
  cs.loading = true; cs.error = ''; redraw();
  try {
    const data = await listCustomers('');
    cs.fullList = data.customers || [];
    applyFilter();
    cs.loaded = true;
  } catch (e) {
    cs.error = e.message || t('customers.loadError');
  } finally {
    cs.loading = false; redraw();
  }
}

async function openCustomer(id) {
  cs.selectedId = id;
  cs.detail = null;
  cs.detailLoading = true;
  cs.detailError = '';
  redraw();
  try {
    cs.detail = await getCustomer(id);
  } catch (e) {
    cs.detailError = e.message || t('customers.genericError');
  } finally {
    cs.detailLoading = false; redraw();
  }
}

function closeDetail() {
  cs.selectedId = null;
  cs.detail = null;
  redraw();
}

// ── action handler (CompanyDashboard delegate mikonad) ──
// return true agar action shenakhte shod
// baraye CompanyDashboard: aya nama-ye detail baz ast? (mobile back btn)
export function isCustomerDetailOpen() { return !!cs.selectedId; }
export function isNewFormOpen() { return !!cs.showNewForm; }
export function isTrashOpen() { return !!cs.showTrash; }

async function loadTrash() {
  cs.trashLoading = true; cs.trashError = ''; redraw();
  try {
    const data = await listTrashedCustomers();
    cs.trashList = data.customers || [];
  } catch (e) {
    cs.trashError = e.message || t('customers.loadError');
  } finally {
    cs.trashLoading = false; redraw();
  }
}

async function doTrash(id) {
  cs.actionBusyId = id; cs.ctxMenu = null; redraw();
  try {
    await trashCustomer(id);
    // agar kart-e baz hamin bud, beband
    if (cs.selectedId === id) { cs.selectedId = null; cs.detail = null; }
    await loadCustomers();
  } catch (e) {
    // Bugfix: hiess vorher 'has_documents' (kleingeschrieben) — das Backend sendete den
    // Code nie in dieser Form, der Check lief nur über den status===409-Fallback.
    if (e.code === 'CUSTOMER_HAS_DOCUMENTS' || e.status === 409) {
      alert(t('customers.hasDocumentsError'));
    } else {
      alert(e.message || t('customers.deleteError'));
    }
  } finally {
    cs.actionBusyId = null; redraw();
  }
}

async function doRestore(id) {
  cs.actionBusyId = id; redraw();
  try {
    await restoreCustomer(id);
    await loadTrash();
    await loadCustomers();
  } catch (e) {
    alert(e.message || t('customers.restoreError'));
  } finally {
    cs.actionBusyId = null; redraw();
  }
}

async function doDeletePermanent(id) {
  if (!confirm(t('customers.confirmDeletePermanent'))) return;
  cs.actionBusyId = id; redraw();
  try {
    await deleteCustomerPermanent(id);
    await loadTrash();
  } catch (e) {
    alert(e.message || t('customers.deletePermanentError'));
  } finally {
    cs.actionBusyId = null; redraw();
  }
}

async function saveNewCustomer() {
  const f = cs.newForm || {};
  const persons = Array.isArray(f.persons) ? f.persons : [];
  const name = (f.name || '').trim();
  if (!name) { cs.newError = t('customers.nameRequired'); redraw(); return; }
  const email = (f.email || '').trim();
  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { cs.newError = t('customers.invalidEmail'); redraw(); return; }
  cs.newBusy = true; cs.newError = ''; redraw();
  try {
    const res = await createCustomer({
      name,
      phone_number: (f.phone || '').trim(),
      email,
      street: (f.street || '').trim(),
      postal_code: (f.plz || '').trim(),
      city: (f.city || '').trim(),
    });
    const r = res && res.result;
    if (res.success && r && r.result === 'created') {
      // sakhte shod → form beband va kart-ash ra baz kon
      cs.showNewForm = false;
      cs.newBusy = false;
      cs.newForm = { name: '', phone: '', street: '', plz: '', city: '', email: '' };
      // rabet-ha ra ba'd az sakht-e moshtari befrest (har kodam ke aslan por shode)
      const newId = r.customer && r.customer.id;
      if (newId && Array.isArray(persons) && persons.length) {
        for (const p of persons) {
          const nm = (p.name || '').trim();
          const em = (p.email || '').trim();
          const ph = (p.phone || '').trim();
          const ro = (p.role || '').trim();
          if (!nm && !em && !ph && !ro) continue; // radif-e khali ra rad kon
          try { await createContactPerson(newId, { name: nm, email: em, phone: ph, role: ro }); } catch (_) {}
        }
      }
      await loadCustomers();
      // be CompanyDashboard (Kunden 2) khabar bede ta list-ash ra refresh konad
      window.dispatchEvent(new CustomEvent('cust2-customer-created', { detail: { id: newId } }));
      if (newId) openCustomer(newId);
      return;
    }
    if (res.success && r && r.result === 'already_exists') {
      // telefon ya email tekrari → payam-e khata, form baz bemanad
      const nm = r.customer && r.customer.name ? r.customer.name : '';
      cs.newError = nm
        ? t('customers.duplicateContactNamed', { name: nm })
        : t('customers.duplicateContact');
      cs.newBusy = false; redraw();
      return;
    }
    cs.newError = (r && r.detail) || res.error || t('customers.createError');
  } catch (e) {
    cs.newError = e.message || t('customers.genericError');
  }
  cs.newBusy = false; redraw();
}

export function handleCustomerAction(action, el) {
  switch (action) {
    case 'cust-open':   openCustomer(el.dataset.id); return true;
    case 'cust-close':  closeDetail(); return true;
    case 'cust-reload': loadCustomers(); return true;
    case 'cust-new':
      cs.showNewForm = true; cs.newError = '';
      cs.newForm = { name: '', phone: '', street: '', plz: '', city: '', email: '' };
      redraw(); return true;
    case 'cust-new-cancel': cs.showNewForm = false; cs.newError = ''; redraw(); return true;
    case 'cust-new-save': saveNewCustomer(); return true;
    case 'cust-person-add':
      if (cs.newForm) { (cs.newForm.persons = cs.newForm.persons || []).push({ name: '', email: '', phone: '', role: '' }); redraw(); }
      return true;
    case 'cust-person-remove': {
      const i = parseInt(el.dataset.idx, 10);
      if (cs.newForm && cs.newForm.persons && !isNaN(i)) { cs.newForm.persons.splice(i, 1); redraw(); }
      return true;
    }
    case 'cust-trash-open': cs.showTrash = true; loadTrash(); return true;
    case 'cust-trash-close': cs.showTrash = false; redraw(); return true;
    case 'cust-ctx-trash': if (el.dataset.id) doTrash(el.dataset.id); return true;
    case 'cust-restore': if (el.dataset.id) doRestore(el.dataset.id); return true;
    case 'cust-delete-perm': if (el.dataset.id) doDeletePermanent(el.dataset.id); return true;
    case 'cust-ctx-close': cs.ctxMenu = null; redraw(); return true;
    case 'cust-search-clear': {
      cs.search = '';
      const inp = document.querySelector('[data-cust-search]');
      if (inp) { inp.value = ''; }
      applyFilter();
      patchCustList();
      if (inp) inp.focus();
      return true;
    }
    default: return false;
  }
}

// search input ra CompanyDashboard be inja mireساند
// filter dar hafeze (bedoon-e darkhast-e server)
function applyFilter() {
  const q = cs.search.trim().toLowerCase();
  if (!q) { cs.list = cs.fullList.slice(); return; }
  cs.list = cs.fullList.filter((c) => {
    return [c.name, c.email, c.phone, c.company]
      .filter(Boolean)
      .some((v) => String(v).toLowerCase().includes(q));
  });
}

export function handleCustomerSearch(value) {
  cs.search = value;
  applyFilter();
  // faghat list ra patch kon, input dast nakhorad (mobile keyboard naparad)
  patchCustList();
}

// list ra dar DOM jایgozin kon bedoon-e redraw-e kamel + namایsh-e dokme-ye x
function patchCustList() {
  const host = document.querySelector('.cust-list-host');
  if (host) {
    host.innerHTML = listHtml(); // input dast nakhorad (mobile keyboard naparad)
  } else {
    redraw(); // fallback: agar host nist
  }
  // toggle-e dokme-ye x (bedoon-e lams-e input)
  const clearBtn = document.querySelector('.cust-search-clear');
  if (clearBtn) clearBtn.classList.toggle('show', !!cs.search);
}

// ── render helpers ──
function channelIcon(ch) {
  if (ch === 'email') return icon('mail', 16);
  if (ch === 'whatsapp') return icon('chat', 16);
  if (ch === 'phone') return icon('call', 16);
  if (ch === 'document') return icon('description', 16);
  return icon('edit', 16);
}

// icon-e rویداد: faktur (Rechnung) → receipt; baghie → channelIcon
function eventIcon(i) {
  if (i.channel === 'document' && typeof i.summary === 'string' && i.summary.startsWith('Rechnung')) {
    return icon('receipt_long', 16);
  }
  return channelIcon(i.channel);
}

// label-e ensani baraye kanal-e ersal
function sentChannelLabel(ch) {
  if (ch === 'whatsapp') return 'WhatsApp'; // Produktname — nicht übersetzen
  if (ch === 'email') return t('customers.email');
  return '';
}

// icon-e jahat/status: rویداد-e document-e draft → saat-sheni; baghie → arrow
function dirIcon(i) {
  if (i.channel === 'document' && i.docStatus === 'draft') return icon('hourglass_empty', 14);
  return icon(i.direction === 'outbound' ? 'arrow_upward' : 'arrow_downward', 14);
}

// matn-e meta: Entwurf / gesendet (WhatsApp) / gesendet / erhalten  + von <name>
function eventMeta(i) {
  let base;
  if (i.channel === 'document') {
    if (i.docStatus === 'sent') {
      const ch = sentChannelLabel(i.sentChannel);
      base = ch ? t('customers.timeline.sentVia', { channel: ch }) : t('customers.timeline.sent');
    } else {
      base = t('customers.timeline.draft');
    }
  } else {
    base = i.direction === 'outbound' ? t('customers.timeline.sent') : t('customers.timeline.received');
  }
  if (i.createdBy && i.createdBy.name) base += t('customers.timeline.fromSuffix', { name: i.createdBy.name });
  return base;
}

// faghat saat: 14:30
function fmtTime(d) {
  if (!d) return '';
  try {
    return time(d);
  } catch { return ''; }
}

// ajzaye tarikh joda: { day:'21', month:'Juni', year:'2026' }
function dateParts(d) {
  if (!d) return { day: '', month: '', year: '' };
  try {
    const dt = new Date(d);
    return {
      day: String(dt.getDate()).padStart(2, '0'),
      month: monthLong(d),
      year: String(dt.getFullYear()),
    };
  } catch { return { day: '', month: '', year: '' }; }
}

// kelid-e rooz baraye group (YYYY-MM-DD ta hamه-ye event-haye yek rooz yeki shavand)
function dayKey(d) {
  if (!d) return '';
  try {
    const dt = new Date(d);
    return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
  } catch { return ''; }
}

// group kardan-e interaction-ha bar asas-e rooz (tartib: jadidtarin avval)
function groupByDay(items) {
  const groups = [];
  const map = {};
  for (const it of items) {
    const k = dayKey(it.occurredAt);
    if (!map[k]) { map[k] = { key: k, parts: dateParts(it.occurredAt), items: [] }; groups.push(map[k]); }
    map[k].items.push(it);
  }
  return groups;
}

// render-e timeline-e interaction-ha (qabel-e estefade-ye mojaddad: CustomersView + Kunden 2)
export function renderInteractionTimeline(interactions) {
  const ints = interactions || [];
  const groups = groupByDay(ints);
  if (!groups.length) {
    return `<div class="cust-state cust-empty"><span>${escapeHtml(t('customers.noInteractions'))}</span></div>`;
  }
  return groups.map((g) => `
    <div class="cust-day">
      <div class="cust-day-date">
        <span class="cust-date-day">${escapeHtml(g.parts.day)}</span>
        <span class="cust-date-month">${escapeHtml(g.parts.month)}</span>
        <span class="cust-date-year">${escapeHtml(g.parts.year)}</span>
      </div>
      <div class="cust-day-rail"><span class="cust-day-circle"></span></div>
      <div class="cust-day-events">
        ${g.items.map((i) => `
          <div class="cust-event">
            <span class="cust-event-time">${escapeHtml(fmtTime(i.occurredAt))}</span>
            <span class="cust-event-dot cust-dot-${escapeHtml(i.channel)}">${eventIcon(i)}</span><span class="cust-event-dir">${dirIcon(i)}</span>
            <div class="cust-event-body">
              <span class="cust-event-summary">${escapeHtml(i.summary || i.rawContent || i.channel)}</span>
              <span class="cust-event-meta">${escapeHtml(eventMeta(i))}</span>
            </div>
          </div>`).join('')}
      </div>
    </div>`).join('');
}

function listHtml() {
  if (cs.loading && !cs.loaded) {
    return `<div class="cust-state">${icon('hourglass_empty', 28)}<span>${escapeHtml(t('customers.loadingList'))}</span></div>`;
  }
  if (cs.error) {
    return `<div class="cust-state cust-err">${icon('error', 28)}<span>${escapeHtml(cs.error)}</span></div>`;
  }
  if (!cs.list.length) {
    return `<div class="cust-state">${icon('groups', 28)}<span>${escapeHtml(t('customers.emptyList'))}</span></div>`;
  }
  const rows = cs.list.map((c) => {
    const display = c.name && c.name !== c.email ? c.name : (c.company || c.email);
    const sub = [c.email, c.phone].filter(Boolean).join(' · ');
    const count = c._count?.interactions ?? 0;
    return `
      <button class="cust-row ${cs.selectedId === c.id ? 'active' : ''}" data-action="cust-open" data-id="${escapeHtml(c.id)}">
        <div class="cust-row-main">
          <span class="cust-row-name">${escapeHtml(display)}</span>
          <span class="cust-row-sub">${escapeHtml(sub)}</span>
        </div>
        <div class="cust-row-meta">
          ${c.verified ? `<span class="cust-badge cust-badge-ok">${icon('check', 12)}</span>` : ''}
          <span class="cust-row-count">${count} ${icon('forum', 12)}</span>
        </div>
      </button>`;
  }).join('');
  return `<div class="cust-list">${rows}</div>`;
}

function detailHtml() {
  if (cs.detailLoading) {
    return `<div class="cust-state">${icon('hourglass_empty', 28)}<span>${escapeHtml(t('customers.loadingList'))}</span></div>`;
  }
  if (cs.detailError) {
    return `<div class="cust-state cust-err">${icon('error', 28)}<span>${escapeHtml(cs.detailError)}</span></div>`;
  }
  if (!cs.detail) {
    return `<div class="cust-state cust-empty">${icon('groups', 32)}<span>${escapeHtml(t('customers.selectCustomer'))}</span></div>`;
  }
  const c = cs.detail.customer;
  const ints = cs.detail.interactions || [];
  const display = c.name && c.name !== c.email ? c.name : (c.company || c.email);

  const groups = groupByDay(ints);
  const timeline = groups.length ? groups.map((g) => `
    <div class="cust-day">
      <div class="cust-day-date">
        <span class="cust-date-day">${escapeHtml(g.parts.day)}</span>
        <span class="cust-date-month">${escapeHtml(g.parts.month)}</span>
        <span class="cust-date-year">${escapeHtml(g.parts.year)}</span>
      </div>
      <div class="cust-day-rail"><span class="cust-day-circle"></span></div>
      <div class="cust-day-events">
        ${g.items.map((i) => `
          <div class="cust-event">
            <span class="cust-event-time">${escapeHtml(fmtTime(i.occurredAt))}</span>
            <span class="cust-event-dot cust-dot-${escapeHtml(i.channel)}">${eventIcon(i)}</span><span class="cust-event-dir">${dirIcon(i)}</span>
            <div class="cust-event-body">
              <span class="cust-event-summary">${escapeHtml(i.summary || i.rawContent || i.channel)}</span>
              <span class="cust-event-meta">${escapeHtml(eventMeta(i))}</span>
            </div>
          </div>`).join('')}
      </div>
    </div>`).join('') : `<div class="cust-state cust-empty"><span>${escapeHtml(t('customers.noInteractions'))}</span></div>`;

  return `
    <div class="cust-detail">
      <div class="cust-detail-head">
        <button class="cust-back" data-action="cust-close">${icon('arrow_back', 18)}</button>
        <div class="cust-detail-title">
          <span class="cust-detail-name">${escapeHtml(display)}</span>
          ${c.verified ? `<span class="cust-badge cust-badge-ok">${icon('check', 12)} ${escapeHtml(t('customers.verified'))}</span>` : `<span class="cust-badge">${escapeHtml(t('customers.unverified'))}</span>`}
        </div>
      </div>
      <div class="cust-detail-fields">
        ${c.email ? `<div class="cust-field">${icon('mail', 14)}<span>${escapeHtml(c.email)}</span></div>` : ''}
        ${c.phone ? `<div class="cust-field">${icon('call', 14)}<span>${escapeHtml(c.phone)}</span></div>` : ''}
        ${c.company ? `<div class="cust-field">${icon('business', 14)}<span>${escapeHtml(c.company)}</span></div>` : ''}
        ${(() => { const addr = [c.street, [c.postalCode, c.city].filter(Boolean).join(' ')].filter(Boolean).join(', '); return addr ? `<div class="cust-field">${icon('location_on', 14)}<span>${escapeHtml(addr)}</span></div>` : ''; })()}
      </div>
      <div class="cust-tl-head">${escapeHtml(t('customers.history'))}</div>
      <div class="cust-timeline">${timeline}</div>
    </div>`;
}

// CompanyDashboard in ra dar main render mikonad
export function customersHtml() {
  return `
    <div class="cust-wrap ${cs.selectedId ? 'cust-show-detail' : 'cust-show-list'}">
      <div class="cust-panel cust-panel-list">
        <div class="cust-search-bar">
          <div class="cust-search-wrap">
            <input class="cust-search" type="text" placeholder="${escapeHtml(t('customers.searchPlaceholder'))}" value="${escapeHtml(cs.search)}" data-cust-search />
            <button class="cust-search-clear ${cs.search ? 'show' : ''}" data-action="cust-search-clear" aria-label="${escapeHtml(t('customers.clearSearchAriaLabel'))}" type="button">${icon('close', 16)}</button>
          </div>
          <button class="cust-new-btn" data-action="cust-new" type="button">${icon('person_add', 16)}<span>${escapeHtml(t('customers.newCustomer'))}</span></button>
          <button class="cust-trash-btn" data-action="cust-trash-open" type="button" title="${escapeHtml(t('customers.trash'))}" aria-label="${escapeHtml(t('customers.trash'))}">${icon('delete', 18)}</button>
        </div>
        <div class="cust-list-host">${listHtml()}</div>
      </div>
      <div class="cust-panel cust-panel-detail">
        ${detailHtml()}
      </div>
    </div>
    ${cs.showNewForm ? newCustomerFormHtml() : ''}
    ${cs.ctxMenu ? contextMenuHtml() : ''}
    ${cs.showTrash ? trashViewHtml() : ''}`;
}

function contextMenuHtml() {
  const m = cs.ctxMenu;
  if (!m) return '';
  // menu kenar-e noghte-ye click; ba CSS jaygiri mishavad
  return `
    <div class="cust-ctx-overlay" data-action="cust-ctx-close">
      <div class="cust-ctx-menu" data-stop="1" style="left:${m.x}px; top:${m.y}px;">
        <button class="cust-ctx-item cust-ctx-danger" data-action="cust-ctx-trash" data-id="${escapeHtml(m.id)}" type="button">
          ${icon('delete', 16)}<span>${escapeHtml(t('common.delete'))}</span>
        </button>
      </div>
    </div>`;
}

export function trashViewHtml() {
  let inner;
  if (cs.trashLoading) {
    inner = `<div class="cust-state">${icon('hourglass_empty', 28)}<span>${escapeHtml(t('common.loading'))}</span></div>`;
  } else if (cs.trashError) {
    inner = `<div class="cust-state cust-err">${icon('error', 28)}<span>${escapeHtml(cs.trashError)}</span></div>`;
  } else if (!cs.trashList.length) {
    inner = `<div class="cust-state">${icon('delete_outline', 32)}<span>${escapeHtml(t('customers.trashEmpty'))}</span></div>`;
  } else {
    inner = cs.trashList.map((c) => {
      const nm = c.name || c.company || c.email || '—';
      const sub = [c.email, c.phone].filter(Boolean).join(' · ');
      const busy = cs.actionBusyId === c.id;
      return `
        <div class="cust-trash-row">
          <div class="cust-trash-info">
            <div class="cust-trash-name">${escapeHtml(nm)}</div>
            ${sub ? `<div class="cust-trash-sub">${escapeHtml(sub)}</div>` : ''}
          </div>
          <div class="cust-trash-actions">
            <button class="cust-trash-restore" data-action="cust-restore" data-id="${escapeHtml(c.id)}" type="button" ${busy ? 'disabled' : ''}>${icon('restore', 16)}<span>${escapeHtml(t('customers.restore'))}</span></button>
            <button class="cust-trash-del" data-action="cust-delete-perm" data-id="${escapeHtml(c.id)}" type="button" ${busy ? 'disabled' : ''}>${icon('delete_forever', 16)}</button>
          </div>
        </div>`;
    }).join('');
  }
  return `
    <div class="cust-new-overlay">
      <div class="cust-trash-box" data-stop="1">
        <button class="cust-new-x" data-action="cust-trash-close" type="button" aria-label="${escapeHtml(t('common.close'))}">${icon('close', 18)}</button>
        <div class="cust-new-title">${escapeHtml(t('customers.trash'))}</div>
        <div class="cust-trash-list">${inner}</div>
      </div>
    </div>`;
}

export function newCustomerFormHtml() {
  const f = cs.newForm || { name:'', phone:'', street:'', plz:'', city:'', email:'' };
  const err = cs.newError ? `<div class="cust-new-err">${escapeHtml(cs.newError)}</div>` : '';
  const busy = cs.newBusy;
  return `
    <div class="cust-new-overlay">
      <div class="cust-new-box" data-stop="1">
        <button class="cust-new-x" data-action="cust-new-cancel" type="button" aria-label="${escapeHtml(t('common.close'))}">${icon('close', 18)}</button>
        <div class="cust-new-title">${escapeHtml(t('customers.newCustomer'))}</div>
        <label class="cust-new-label">${escapeHtml(t('common.name'))}<input class="cust-new-input" id="cust-new-name" data-cust-field="name" type="text" autocomplete="off" value="${escapeHtml(f.name)}" /></label>
        <label class="cust-new-label">${escapeHtml(t('customers.phone'))}<input class="cust-new-input" data-cust-field="phone" type="tel" inputmode="tel" autocomplete="off" placeholder="0791234567" value="${escapeHtml(f.phone)}" /></label>
        <label class="cust-new-label">${escapeHtml(t('customers.street'))}<input class="cust-new-input" data-cust-field="street" type="text" autocomplete="off" placeholder="Bahnhofstrasse 12" value="${escapeHtml(f.street)}" /></label>
        <div class="cust-new-row">
          <label class="cust-new-label cust-new-plz">${escapeHtml(t('customers.postalCode'))}<input class="cust-new-input" data-cust-field="plz" type="text" inputmode="numeric" autocomplete="off" placeholder="8001" value="${escapeHtml(f.plz)}" /></label>
          <label class="cust-new-label cust-new-ort">${escapeHtml(t('customers.city'))}<input class="cust-new-input" data-cust-field="city" type="text" autocomplete="off" placeholder="Zürich" value="${escapeHtml(f.city)}" /></label>
        </div>
        <label class="cust-new-label">${escapeHtml(t('customers.email'))}<input class="cust-new-input" data-cust-field="email" type="email" inputmode="email" autocomplete="off" autocapitalize="off" spellcheck="false" placeholder="name@example.com" value="${escapeHtml(f.email)}" /></label>
        <div class="cust-persons-section">
          <div class="cust-persons-head">
            <span class="cust-persons-title">${icon('group', 15)}<span>${escapeHtml(t('customers.contactPersons'))}</span></span>
            <button class="cust-persons-add" data-action="cust-person-add" type="button">${icon('add', 15)}<span>${escapeHtml(t('common.add'))}</span></button>
          </div>
          ${(f.persons && f.persons.length) ? f.persons.map((p, i) => `
            <div class="cust-person-card">
              <button class="cust-person-del" data-action="cust-person-remove" data-idx="${i}" type="button" aria-label="${escapeHtml(t('customers.removePerson'))}">${icon('close', 15)}</button>
              <input class="cust-new-input cust-person-in" data-person-idx="${i}" data-person-field="name" type="text" autocomplete="off" placeholder="${escapeHtml(t('common.name'))}" value="${escapeHtml(p.name || '')}" />
              <input class="cust-new-input cust-person-in" data-person-idx="${i}" data-person-field="role" type="text" autocomplete="off" placeholder="${escapeHtml(t('customers.personRolePlaceholder'))}" value="${escapeHtml(p.role || '')}" />
              <input class="cust-new-input cust-person-in" data-person-idx="${i}" data-person-field="phone" type="tel" inputmode="tel" autocomplete="off" placeholder="${escapeHtml(t('customers.phone'))}" value="${escapeHtml(p.phone || '')}" />
              <input class="cust-new-input cust-person-in" data-person-idx="${i}" data-person-field="email" type="email" inputmode="email" autocomplete="off" autocapitalize="off" spellcheck="false" placeholder="${escapeHtml(t('customers.email'))}" value="${escapeHtml(p.email || '')}" />
            </div>`).join('') : `<div class="cust-persons-empty">${escapeHtml(t('customers.contactPersonEmptyHint'))}</div>`}
        </div>
        ${err}
        <div class="cust-new-actions">
          <button class="cust-new-cancel" data-action="cust-new-cancel" type="button" ${busy ? 'disabled' : ''}>${escapeHtml(t('common.cancel'))}</button>
          <button class="cust-new-save" data-action="cust-new-save" type="button" ${busy ? 'disabled' : ''}>${escapeHtml(busy ? t('customers.creating') : t('customers.create'))}</button>
        </div>
      </div>
    </div>`;
}
